export const DataHooks = {
  Root: 'AlertDialog.Root',
  Title: 'AlertDialog.Title',
  Description: 'AlertDialog.Description',
  SubmitButton: 'AlertDialog.SubmitButton',
  CancelButton: 'AlertDialog.CancelButton',
} as const;
